export default {
  path: "leads_history",
  name: "Leads",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      component: () => import("@/views/leads/leadsHistory.vue"),
    },
    {
      path: "createLead",
      name: "Create Lead",
      component: () => import("@/views/leads/createLead.vue"),
    },
    {
      path: "viewLead/:id",
      name: "View Lead",
      component: () => import("@/views/leads/viewLead.vue"),
    },
    {
      path: "editLead/:id",
      name: "Edit Lead",
      component: () => import("@/views/leads/editLead.vue"),
    },
    {
      path: "quote/:id",
      name: "Quote Details",
      component: () => import("@/views/leads/quoteDetails.vue"),
    },
  ],
};
